import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IAlarmsByDeviceStatusFilter, IColSeriesData } from "../../Models/IStatistics";

@Injectable({
  providedIn: 'root'
})
export abstract class AbstractStatsService {

  abstract get deviceStatusData(): any[];
  abstract GetdeviceStatusCountColumnChartConfig(result: Array<IColSeriesData>, xAxisCategory: Array<string>): any;
  abstract get getdeviceByGroupPieChartConfig(): Highcharts.Options;
  abstract get alarmsByDeviceOverTimeStockConfig(): Highcharts.Options;
  abstract GetAlarmsCountByDistriConfig(xCategories: Array<string>, data: IAlarmsByDeviceStatusFilter): Highcharts.Options;
  abstract get deviceStatusCountDateRangeLabelsColumn(): any[];
  abstract get deviceStatusValueLabels(): any[];
  abstract get distributionTimeRange(): any[];
  abstract GetDataForStatisticsBarChart(deviceFilter: IAlarmsByDeviceStatusFilter, startDate: Date, endDate: Date): Observable<any>;
  abstract GetDataForStatisticsPieChart(deviceFilter: IAlarmsByDeviceStatusFilter, startDate: Date, endDate: Date): Observable<any>;
  abstract GetDataForAlarmStockChart(deviceFilter: IAlarmsByDeviceStatusFilter): Observable<any>;
    abstract GroupDeviceInfoByDeviceStatus(groupId: number, status: number): Observable<any>;
  abstract GetGroupsByGroupIdsAndDeviceStatus(deviceFilter: IAlarmsByDeviceStatusFilter): Observable<any>;
  abstract readonly colChartClicked$: Observable<any>;
  abstract readonly pieChartClicked$: Observable<any>;
  abstract readonly stockChartClicked$: Observable<any>;
  abstract GetDeviceCountByUser(): Observable<any>;
  abstract GetDeviceCountByStatus(status: number): Observable<any>;
  abstract GetGroupByUserAndDeviceStatus(status: number): Observable<any>;
  abstract GetControllerTypeByGroups(GroupIds: Array<number>, status: number);
  abstract GetDeviceListData(): Observable<any>;
  abstract GetAlarmDataForBarchartClick(deviceId: number, status: number, isActive: boolean, startDate: Date, endDate: Date): Observable<any>;
  abstract GetAlarmDataForPiechartClick(deviceFilter: IAlarmsByDeviceStatusFilter, status: number, isActive: boolean, startDate: Date, endDate: Date): Observable<any>;
  abstract GetDataForAlarmStockChartClick(deviceFilter: IAlarmsByDeviceStatusFilter, status: number, isActive: boolean, selectedDate: Date): Observable<any>;
  abstract GetDataForAlarmRadarChart(deviceFilter: IAlarmsByDeviceStatusFilter, timeInterval: number): Observable<any>;

}
